<template>
  <div class="profil-container" v-if="registrasi && registrasi.length > 0">
    <h3 class="profil-title">
      <span v-if="isEdit" class="editRow" @click="editRow(registrasi[0])"><span
          class="fa fa-edit pointer ml20"></span></span>
      {{ registrasi[0].text }}
    </h3>
    <div class="instruction-wrapper flex-row">
      <span v-if="isEdit" @click="editRow(registrasi[1])" class="fa fa-edit pointer ml20"></span>
      <div class="flex-col">
        <div v-for="(item, index) in instructions" :key="index" class="instruction-list">
          <div class="instruction-number">{{ index + 1 }}.</div>
          <div class="instruction-text" v-html="highlightStars(item)"></div>
        </div>
      </div>

    </div>

    <div class="profil-btn-wrapper">
      <div @click="goProfile()" class="btn-landing">Selanjutnya</div>
    </div>
    <EditPertanyaan v-if="showModalEdit" :editData="editData" @closeModal="closeModal" class="notAll" />
  </div>
</template>


<script>
export default {
  components: {
    EditPertanyaan: () => import('@/components/masterdata/landing-page/edit/edit-pertanyaan.vue')
  },
  props: {
    isEdit: Boolean
  },
  data() {
    return {
      showModalEdit: false,
      editData: null
    }
  },

  computed: {
    instructions() {
      return this.splitText(this.registrasi[1].text);
    },
    registrasi() {
      const data = this.$store.state.mdLandingStore.registrasi
      return data
    }
  },
  methods: {
    goProfile() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'profilebu')
    },
    splitText(text) {
      return text.split(/\d+\./).filter(item => item.trim());
    },
    highlightStars(text) {
      return text.replace(/\*/g, "<span style='color: red;'>*</span>");
    },

    editRow(data) {
      this.editData = data
      this.showModalEdit = true;
    },

    closeModal() {
      this.showModalEdit = false;
    },
  },


}
</script>